import { v4 as uuid } from 'uuid';

import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'fable/flowEditor/components/flowManager/canvas/node/text';
import { TextContent } from 'fable/flowEditor/components/flowManager/canvas/node/textContent';
import { TextEllipsis } from 'fable/flowEditor/components/flowManager/canvas/node/textEllipsis';
import { hexStringToNumber } from 'fable/flowEditor/components/flowManager/canvas/renderers/common/colors';
import {
  GenericNodeAttributes,
  GenericNodeProps,
} from 'fable/flowEditor/components/flowManager/canvas/types/node';

import { FlowMessengerNodeCustomFormPayload } from '../../../flow.types';
import { MessengerCustomFormNodeModal } from '../components/customFormsModal';

const translatePayload: MessengerCustomFormNodeAttributes['translatePayload'] =
  ({ payload }) => {
    return [
      {
        id: uuid(),
        label: 'arrow',
        connection: payload.nextNodeId || uuid(),
      },
    ];
  };

const updateConnection: MessengerCustomFormNodeAttributes['updateConnection'] =
  (node, _connection, connectionId) => {
    return {
      ...node,
      payload: {
        ...node.payload,
        nextNodeId: connectionId,
      },
    };
  };

type MessengerCustomFormNodeAttributes =
  GenericNodeAttributes<FlowMessengerNodeCustomFormPayload>;

export const MessengerCustomFormNodeAttributes: MessengerCustomFormNodeAttributes =
  {
    iconName: 'list-ul',
    label: 'Form',
    color: hexStringToNumber(flowNodeColor.orange),
    translatePayload,
    updateConnection,
    NodeContent: MessengerCustomFormNode,
    ActionModal: MessengerCustomFormNodeModal,
  };

type MessengerCustomFormNodeProps =
  GenericNodeProps<FlowMessengerNodeCustomFormPayload>;

export function MessengerCustomFormNode({
  node,
}: MessengerCustomFormNodeProps): JSX.Element {
  const { payload } = node;
  const { formTitle } = payload;

  return (
    <TextContent maxLines={2}>
      <TextEllipsis>
        <Text weight="semibold" text={formTitle} />
      </TextEllipsis>
    </TextContent>
  );
}
